import { type FC } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

interface DotAnimationProps {
  className?: string;
}

const DotAnimation: FC<DotAnimationProps> = ({ className }) => {
  return <span className={cn(css.pulse, className)}></span>;
};

export { DotAnimation };
